var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.title},[_vm._v("403")]),_c('div',{class:_vm.$style.description},[_vm._v(" "+_vm._s(_vm.$t('T_RESPONSE_403')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }